import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AdminAuthProvider, useAdminAuth } from "@/context/AdminAuth";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/AdminLayout";
import AdminInbox from "@/pages/AdminInbox";
import Tasks from "@/pages/Tasks";
import Subscribers from "@/pages/Subscribers";
import ApiKeys from "@/pages/ApiKeys";

function Protected({ children }) {
  const { admin, loading } = useAdminAuth();
  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center text-slate-400" data-testid="auth-loading">
        Завантаження...
      </div>
    );
  }
  return admin ? children : <Navigate to="/admin/login" replace />;
}

function App() {
  return (
    <BrowserRouter>
      <AdminAuthProvider>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Navigate to="/admin/login" replace />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Protected><AdminLayout /></Protected>}>
            <Route index element={<AdminInbox />} />
            <Route path="tasks" element={<Tasks />} />
            <Route path="subscribers" element={<Subscribers />} />
            <Route path="help" element={<Home />} />
          </Route>
          <Route path="/admin/keys" element={<Protected><ApiKeys /></Protected>} />
          <Route path="*" element={<Navigate to="/admin/login" replace />} />
        </Routes>
      </AdminAuthProvider>
    </BrowserRouter>
  );
}

export default App;
